import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./MainLayout.css";

const { Content } = Layout;

const MainLayout = () => (
    <Layout className="main-layout">
        {/* Navbar at the top */}
        <Navbar />

        <Layout className="body-layout">
            {/* Sidebar takes full height */}
            <Sidebar className="sidebar" />

            {/* Content area expands fully */}
            <Layout className="content-layout">
                <Content className="content-container">
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    </Layout>
);

export default MainLayout;
